export const getVisitors = (state) => state.Visitors